import { PublishFileRecordDialog } from "@/action-dialog/dialogs/PublishFileRecordDialog";
import type { FileRecord } from "@cohesive/api-client";
import { useRef } from "react";
import { createCallable } from "react-call";

const UNMOUNTING_DELAY_MS = 200;

export type PublishFileRecordCallableProps = {
  record: FileRecord;
};

export const PublishFileRecordCallable = createCallable<
  PublishFileRecordCallableProps,
  boolean
>(({ call, record }) => {
  const succeededRef = useRef(false);

  return (
    <PublishFileRecordDialog
      record={record}
      onClose={() => {
        call.end(succeededRef.current);
        succeededRef.current = false;
      }}
      onSuccess={() => {
        succeededRef.current = true;
      }}
    />
  );
}, UNMOUNTING_DELAY_MS);

PublishFileRecordCallable.displayName = "PublishFileRecordCallable";
